export const categories = [
  {
    slug: "short",
    name: "短视频",
    icon: "ri-flashlight-line",
    tone: "primary",
    description: "节奏轻快、时长精简的精彩短片，碎片时间也能一次看个够，几秒钟就抓住你的注意力。",
    intro: "精选高能短片合集，通勤、排队、休息间隙都能轻松观看。",
  },
  {
    slug: "entertainment",
    name: "娱乐",
    icon: "ri-emotion-happy-line",
    tone: "accent",
    description: "搞笑短剧、综艺名场面、音乐现场与明星花絮，快乐一秒到达，笑点和惊喜从不缺席。",
    intro: "快乐源泉集中地，让你笑出声的娱乐内容都在这里。",
  },
  {
    slug: "life",
    name: "生活",
    icon: "ri-leaf-line",
    tone: "secondary",
    description: "美食、居家、旅行与日常记录，发现平凡日子里的小美好，和有趣的人一起热爱生活。",
    intro: "记录真实生活，分享那些让人会心一笑的日常瞬间。",
  },
];

export const categorySlugs = ["short", "entertainment", "life"];